import { Badge, makeStyles } from '@coreai/fluentui-react';
import { workflowListMessages } from './workflowListMessages';

const useStyles = makeStyles({
  badge: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
});

export const WorkflowUnpublishedBadge = () => {
  const styles = useStyles();
  return (
    <Badge
      className={styles.badge}
      appearance="tint"
      color="warning"
      size="small"
      aria-label={workflowListMessages.unpublishedChanges}
    >
      {workflowListMessages.unpublishedChanges}
    </Badge>
  );
};
